import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import { ENVIRONMENT } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FeatureFlagUsecase } from './application/feature-flags/feature-flag-use-case.service';
import { I18nDisplayerService } from './application/usesCases/i18n-displayer.service';
import { MfListServiceUseCase } from './application/usesCases/mf-list.service';
import { PushNotificationUseCase } from './application/usesCases/push-notification/pushNotification.service';
import { FeatureFlagPort } from './domain/features-flags/port/feature-flag.port';
import { AmplifyConfig } from './infraestructure/adapters/amplify/amplify-config';
import { UnleashAdapter } from './infraestructure/adapters/feature-flags/unleash/unleash.service.adapter.service';
import { MfListAdapterService } from './infraestructure/adapters/mf-list-adapter.service';
import { PushNotificationAdapter } from './infraestructure/adapters/push-notification/push-notification-adapter.service';
import { interceptorsProviders } from './infraestructure/ui/interceptors/interceptors';
import { AuthModule } from './infraestructure/ui/pages/auth/auth.module';
import { SpinnerComponent } from './infraestructure/ui/pages/spinner/spinner.component';
import { MissingTranslationHandlerService } from './infraestructure/ui/services/missing-translation-handler.service';
import { PlanModule } from './plan/plan.module';
import { TestComponent } from './test/test.component';

Amplify.configure(AmplifyConfig, { ssr: true });

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: ENVIRONMENT.domain,
    sameSite: 'none',
    secure: true,
  })
);

@NgModule({
  declarations: [AppComponent, TestComponent, SpinnerComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: I18nDisplayerService,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationHandlerService,
      },
      isolate: true,
    }),
    ServiceWorkerModule.register('sw-master.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    AuthModule,
    PlanModule,
  ],
  providers: [
    ...interceptorsProviders,
    PushNotificationAdapter,
    PushNotificationUseCase,
    MfListAdapterService,
    MfListServiceUseCase,
    FeatureFlagUsecase,
    { provide: FeatureFlagPort, useClass: UnleashAdapter },
    { provide: 'IPushNotificationPort', useClass: PushNotificationAdapter },
    { provide: 'IAdapterMfListPort', useClass: MfListAdapterService },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
